import * as React from "react";

import moment from "moment";

const styles = require("../styles.module.scss");

interface Props {
  fields: Object;
}

const displayField = (fieldKey, fieldVal) => {
  const isDate =
    /requested date/i.test(fieldKey) ||
    /expected date/i.test(fieldKey) ||
    /approved date/i.test(fieldKey);

  let val;
  if (isDate) {
    val = moment(fieldVal).format("MM/DD/YYYY");
  } else if (typeof fieldVal === "object") {
    val = JSON.stringify(fieldVal);
  } else {
    val = fieldVal;
  }

  return (
    <tr key={fieldKey}>
      <td>{fieldKey}</td>
      <td>{val}</td>
    </tr>
  );
};

export const Fields: React.FC<Props> = ({ fields }) => {
  return (
    <table className={styles.fields}>
      <tbody>{Object.keys(fields).map(k => displayField(k, fields[k]))}</tbody>
    </table>
  );
};
